var $ = require('jquery');

(function ($, window, document, undefined) {

    /*
     * DOCUMENT READY
     */

    $(document).ready(function () {


        /*
         * MOBILE NAVIGATION
         */

        var mobileNavigation = $('#mobile-navigation');
        var mainNavigation = $('#main-navigation');

        mobileNavigation.click(function () {
            mobileNavigation.toggleClass('active');
            if (mainNavigation.hasClass('active')) {
                mainNavigation.removeClass('show');
                mainNavigation.height();
                setTimeout(function () {
                    mainNavigation.removeClass('active');
                }, 400);
            } else {
                mainNavigation.addClass('active');
                mainNavigation.height();
                mainNavigation.addClass('show');
            }
        });

        /*
         * SLIDER
         */
        /*
         $('#slider').owlCarousel({
         items: 1,
         loop: true,
         nav: true,
         navText: ['', ''],
         smartSpeed: 400
         });
         */

        //TOGGLING NESTED ul
        $(document).on("click", ".drop-down .selected a", function () {
            //$('.drop-down .selected a').click(function () {
            $(this).closest('.drop-down').find('.options ul').toggle();
            return false;
        });

        //SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
        $('.drop-down .options ul li a').click(function () {
            var text = $(this).html();
            $(this).closest('.drop-down').find('.selected a span').html(text);
            $(this).closest('.drop-down').find('.options ul').hide();
        });


        //HIDE OPTIONS IF CLICKED ANYWHERE ELSE ON PAGE
        $(document).bind('click', function (e) {
            var $clicked = $(e.target);
            if (!$clicked.parents().hasClass('drop-down'))
                $('.drop-down .options ul').hide();
        });


        $('.navbar-toggle').click(function () {
            $("html, body").scrollTop(0);
            if ($("body").hasClass('no-scroll')) {
                $("body").removeClass('no-scroll');
            } else {
                $("body").addClass('no-scroll');
            }
        });

        $("body:not(.right-header-meta)").click(function () {
            if ($(".search-icon-div").hasClass('active')) {
                $("#sbf-search-input").hide();
                $(".search-icon-div").removeClass('active')
                $(".search").removeClass('active-search');
                $(".right-header-meta").removeClass('active-search-right-meta');

            }
        });


        $('.search-icon-div').click(function (e) {
            $(this).addClass('active');

            if ($(this).hasClass('active')) {
                $("#sbf-search-input").show().focus();
                $(".search").addClass('active-search');
                $(".right-header-meta").addClass('active-search-right-meta');
                $(".navbar-collapse").addClass('show');
                $("body").addClass('no-scroll');
                $(".navbar-toggle").removeClass('collapsed');
            }
            e.stopPropagation();
        });


        $("a[href='#top']").click(function () {
            $("html, body").animate({scrollTop: 0}, "fast");
            return false;
        });

        // HEADER
        var header = $('.sticky-header');
        var hashItems = $('.sub_nav li a');

        hashItems.each(function () {
        });

        $(window).scroll(function () {
            if ($(window).scrollTop() > 10) {
                header.addClass('fixed');
            } else {
                header.removeClass('fixed');
            }
        }).scroll();

        //var offsetSubNav = $(".sub_nav").offset().top;

        //set default active (first child)
        if ($(window).scrollTop() == 0) {
            $(".sub_nav_list").children(".sub_nav_content").first().children().addClass("active")
        }

        //set active if scrolled
        var offsetSubNav = 0;
        $(window).scroll(function () {
            if (offsetSubNav - $(window).scrollTop() <= 400) {
                $(".sub_nav").addClass("sticky");
            }
            //console.log(offsetSubNav);
            hashItems.removeClass("active")

            if ($(window).scrollTop() + $(window).height() == $(document).height()) {
                hashItems.last().addClass("active");
            } else if ($(window).scrollTop() == 0) {
                hashItems.first().addClass("active");
            } else {
                hashItems.filter(function () {

                    if ($(this.hash).offset().top <= $(".sub_nav").offset().top) {
                        return true
                    }

                }).last().addClass("active");
            }
        });


        $(window).scroll(function () {
            if ($(window).scrollTop() <= offsetSubNav - 400) {
                $(".sub_nav").removeClass("sticky");
            }

        });

        if ($('.tx-sbf-portfolio-single').length > 0) {
            $(".sub_nav").addClass("sticky");
        }

        $('a[href*=\\#]').click(function (e) {

            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // only if the link is not the same as the current page
            if (target.length && window.location.href.indexOf($(this).attr('href').split('#')[0]) !== -1) {
                e.preventDefault();
                $('html,body').animate({
                    scrollTop: target.offset().top - $(".sticky-header").outerHeight() + "px"
                }, 1000);
                if (matchMedia('only screen and (max-width: 1000px)').matches) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - $(".sticky-header").outerHeight() + "px"
                    }, 1000);

                    return false;
                }
            }

        });

    });

    $(".remove-text").click(function () {
        $(".edit-portfolio-span").css("display", "none");
    });

    $(".remove-text").click(function () {
        $(".edit-album-span").css("display", "none");
    });

    $(".backendlayout-unterseiteRechteSpalte .col-lg-4 .tx-sbf-portfolio").parent().find("header h1,header h2,header h3,header h4,header h5").addClass("portfolio-header");

    if ($('.drag-list').length > 0) {

        function DragNSort(config) {
            this.$activeItem = null;
            this.$container = config.container;
            this.$items = this.$container.querySelectorAll('.' + config.itemClass);
            this.dragStartClass = config.dragStartClass;
            this.dragEnterClass = config.dragEnterClass;
        }

        DragNSort.prototype.removeClasses = function () {
            [].forEach.call(this.$items, function ($item) {
                $item.classList.remove(this.dragStartClass, this.dragEnterClass);
            }.bind(this));
        };

        DragNSort.prototype.on = function (elements, eventType, handler) {
            [].forEach.call(elements, function (element) {
                element.addEventListener(eventType, handler.bind(element, this), false);
            }.bind(this));
        };

        DragNSort.prototype.onDragStart = function (_this, event) {
            _this.$activeItem = this;

            this.classList.add(_this.dragStartClass);
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/html', this.innerHTML);
        };

        DragNSort.prototype.onDragEnd = function (_this) {
            this.classList.remove(_this.dragStartClass);
        };

        DragNSort.prototype.onDragEnter = function (_this) {
            this.classList.add(_this.dragEnterClass);
        };

        DragNSort.prototype.onDragLeave = function (_this) {
            this.classList.remove(_this.dragEnterClass);
        };

        DragNSort.prototype.onDragOver = function (_this, event) {
            if (event.preventDefault) {
                event.preventDefault();
            }

            event.dataTransfer.dropEffect = 'move';

            return false;
        };

        DragNSort.prototype.onDrop = function (_this, event) {
            if (event.stopPropagation) {
                event.stopPropagation();
            }

            if (_this.$activeItem !== this) {
                _this.$activeItem.innerHTML = this.innerHTML;
                this.innerHTML = event.dataTransfer.getData('text/html');
                var activeItemPosition = $(_this.$activeItem).data('position');
                var isAlbum = $(_this.$activeItem).data('is-portfolio');
                var passiveItemPosition = $(this).data('position')
                var passiveFrontendSorting = $(_this.$activeItem).children(".card-item").data('frontendsorting')
                var activeFrontendSorting = $(this).children(".card-item").data('frontendsorting')
                var neighbourFrontendSorting = $(_this.$activeItem).prev(".drag-item").children(".card-item").data('frontendsorting')
                var passiveUid = $(_this.$activeItem).children(".card-item").data('uid')
                var activeUid = $(this).children(".card-item").data('uid')
                var neighbourUid = $(_this.$activeItem).prev(".drag-item").children(".card-item").data('uid')

                var albumPassiveFrontendSorting = $(_this.$activeItem).children(".card-item").data('frontendsorting-album')
                var albumActiveFrontendSorting = $(this).children(".card-item").data('frontendsorting-album')
                var albumNeighbourFrontendSorting = $(_this.$activeItem).prev(".drag-item").children(".card-item").data('frontendsorting-album')
                var albumPassiveUid = $(_this.$activeItem).children(".card-item").data('uid-album')
                var albumActiveUid = $(this).children(".card-item").data('uid-album')
                var albumNeighbourUid = $(_this.$activeItem).prev(".drag-item").children(".card-item").data('uid-album')


                var itemPosition = {
                    "Sorting": [{
                        "passiveFrontendSorting": passiveFrontendSorting,
                        "activeFrontendSorting": activeFrontendSorting,
                        "neighbourFrontendSorting": neighbourFrontendSorting
                    }],
                    "Uid": [{
                        "passiveUid": passiveUid,
                        "activeUid": activeUid,
                        "neighbourUid": neighbourUid
                    }]
                };


                var itemPositionAlbum = {
                    "Sorting-Album": [{
                        "albumPassiveFrontendSorting": albumPassiveFrontendSorting,
                        "albumActiveFrontendSorting": albumActiveFrontendSorting,
                        "albumNeighbourFrontendSorting": albumNeighbourFrontendSorting
                    }],
                    "Uid-Album": [{
                        "albumPassiveUid": albumPassiveUid,
                        "albumActiveUid": albumActiveUid,
                        "albumNeighbourUid": albumNeighbourUid
                    }]
                };

                //console.log(itemPositionAlbum);

                $.ajax({
                    type: "GET",
                    data: {
                        'tx_sbfportfolio_filtersearch': {
                            'itemPosition': itemPosition,
                            'itemPositionAlbum': itemPositionAlbum,
                            'controller': 'Album',
                            'action': 'ajaxSort'
                        }
                    },
                    dataType: "json",
                    url: "/?type=223"

                });


            }

            _this.removeClasses();

            return false;
        };

        DragNSort.prototype.bind = function () {
            this.on(this.$items, 'dragstart', this.onDragStart);
            this.on(this.$items, 'dragend', this.onDragEnd);
            this.on(this.$items, 'dragover', this.onDragOver);
            this.on(this.$items, 'dragenter', this.onDragEnter);
            this.on(this.$items, 'dragleave', this.onDragLeave);
            this.on(this.$items, 'drop', this.onDrop);
        };

        DragNSort.prototype.init = function () {
            this.bind();
        };

// Instantiate
        var draggable = new DragNSort({
            container: document.querySelector('.drag-list'),
            itemClass: 'drag-item',
            dragStartClass: 'drag-start',
            dragEnterClass: 'drag-enter'
        });

        draggable.init();
    }


    // FEMANAGER
    $("#femanager_field_name").on("input", function () {
        $("#femanager_div_name").html($(this).val());
    })

    // Powermail-Akkordeons
    var powermail_create = $('.powermail_create');
    var powermail_confirmation = $('.powermail_confirmation');

    if (powermail_create.length) {
        powermail_create.parent().parent().parent().parent().addClass('show');
        powermail_create.parent().parent().parent().parent().closest('.card').find('.card-header > a').attr('aria-expanded', 'true');

        powermailId = powermail_create.parent().parent().parent().parent().closest('.card');
        setTimeout($('html, body').animate({
            scrollTop: (powermailId.offset().top - 100)
        }, 500), 1500);
    }

    if (powermail_confirmation.length) {
        powermail_confirmation.parent().parent().parent().parent().addClass('show');
        powermail_confirmation.parent().parent().parent().parent().closest('.card').find('.card-header > a').attr('aria-expanded', 'true');

        powermailId = powermail_confirmation.parent().parent().parent().parent().closest('.card');
        setTimeout($('html, body').animate({
            scrollTop: (powermailId.offset().top - 100)
        }, 500), 1500);
    }


})(jQuery, window, document);



